import classNames from "classnames";
import { useRef } from "react";
import { NodeStates } from "../../build/types";
import { useInteractionStates } from "../../hooks/useInteractionStates";
import { BuilderComponentProps } from "../BuilderInterface";
import { getCompoundStyle, getStateStyleForBuilder, getStylesFromInteractiveStates } from "../helpers";

const BuilderCustomSale: React.FC<BuilderComponentProps> = ({
    node,
    children,
    actionCallbacks,
    dynamicData,
    builderProps,
    disabled,
    selected
}: BuilderComponentProps) => {
    const { id, attr, stateManager, name, backgroundImage } = node;
    const { setElement, states } = useInteractionStates<HTMLDivElement>();
    const div = useRef<HTMLDivElement>(null);

    const builderDivClass = classNames("builder-div", {
        [`${attr?.className}`]: !!attr?.className
    });

    const backgroundImageStyle: React.CSSProperties =
        node.dynamicData || backgroundImage
            ? {
                  backgroundImage: `url("${node.dynamicData ? dynamicData : backgroundImage}")`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat"
              }
            : {};

    if (builderProps) {
        const {
            isContainer,
            nodeState,
            selectedMenu,
            selectCallback,
            outlineCallback,
            onDragOverCapture,
            onDragStart,
            onDragEnd
        } = builderProps;

        return (
            <div
                {...attr}
                ref={div}
                className={builderDivClass}
                style={getCompoundStyle({
                    node,
                    isContainer: isContainer,
                    otherStyle: backgroundImageStyle,
                    stateStyle: getStateStyleForBuilder(stateManager, nodeState, "attr_style")
                })}
                onClick={e => (selectCallback ? selectCallback(e, id) : {})}
                onMouseMove={e => (outlineCallback ? outlineCallback(e, id) : {})}
                id={id}
                onDragOverCapture={e => onDragOverCapture?.(e, id, div.current as HTMLDivElement)}
                onDragStart={e => onDragStart?.(e, id)}
                draggable={name === "repeaterDiv" ? "false" : "true"}
                onDragEnd={onDragEnd}
            >
                {children}
                {selectedMenu}
            </div>
        );
    } else {
        const { style, ...rest } = attr || {};

        const extraStates = (
            disabled || selected ? [selected && NodeStates.SELECTED, disabled && NodeStates.DISABLED].filter(Boolean) : undefined
        ) as NodeStates[];

        const divStyle = getStylesFromInteractiveStates({
            states,
            defaultStyle: getCompoundStyle({ node, otherStyle: backgroundImageStyle }),
            stateManager,
            paths: ["attr_style"],
            ...(extraStates ? { extraStates } : {})
        });

        return (
            <div ref={setElement} style={divStyle} id={id} {...rest} {...actionCallbacks} className={builderDivClass}>
                {children}
            </div>
        );
    }
};

export default BuilderCustomSale;
